export default __webpack_public_path__ + "static/media/Rome.58b9ee43.jpg";